module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAARCAYAAAAYNhYvAAAAGklEQVQImWN0avj0nwECOpigDDAY6hwGBgYAyyMDXTr3cTYAAAAASUVORK5CYII="